import { AuthFetchWithResponse } from 'src/Types/api'
import { ApiResult, throwApiError } from 'src/Libs/api'
import { StatusCodes } from '@e3dc-react/shell/Libs'
import { AuthFetchError } from '@e3dc-react/shell/Types'

export const syncInstallation = async (installationId: number, authFetch: AuthFetchWithResponse): Promise<ApiResult<null>> => {
  try {
    const response = await authFetch({
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
      path: `installations/${installationId}/config/sync`,
      method: 'POST',
    })

    if (response.status !== StatusCodes.OK) {
      return new ApiResult<null, Error | AuthFetchError>(null)
    }

    return new ApiResult<null>(null)
  } catch (error) {
    return throwApiError(error, 'Failed to sync installation:')
  }
}
